import api from "@/api";
import User from "@/types/User";

export default async function userCreate(user: User): Promise<User> {
  const response = await api.post<User>("/api/user", user);

  return response.data;
}
